module.exports = __webpack_public_path__ + "img/add.0ecfa4d4.png";